module.exports = __webpack_public_path__ + "static/media/waiting_for_participants.f87bfc5.mp3";


//////////////////
// WEBPACK FOOTER
// ./static/sounds/waiting_for_participants.mp3
// module id = 396
// module chunks = 1